import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2 pb-5"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", { class: "mb-4" }, "Manual", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClassificationComponent = _resolveComponent("ClassificationComponent")!
  const _component_WorkerRunSummaryComponent = _resolveComponent("WorkerRunSummaryComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.manualClassifications.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manualClassifications, (classification) => {
            return (_openBlock(), _createBlock(_component_ClassificationComponent, {
              key: classification.id,
              classification: classification,
              disabled: !_ctx.canWrite(_ctx.corpus),
              "element-id": _ctx.element.id
            }, null, 8, ["classification", "disabled", "element-id"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workerRunClassifications, ([workerRunId, classifications]) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "mt-2 pb-5",
        key: workerRunId
      }, [
        _createVNode(_component_WorkerRunSummaryComponent, {
          class: "mb-4",
          "worker-run-details": _ctx.workerRunSummaries[workerRunId]
        }, null, 8, ["worker-run-details"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classifications, (classification) => {
          return (_openBlock(), _createBlock(_component_ClassificationComponent, {
            key: classification.id,
            classification: classification,
            disabled: !_ctx.canWrite(_ctx.corpus),
            "element-id": _ctx.element.id
          }, null, 8, ["classification", "disabled", "element-id"]))
        }), 128))
      ]))
    }), 128))
  ]))
}